module.exports = __webpack_public_path__ + "static/media/logo.c0c6fa96.png";